import styled from 'styled-components';
import { getCurrentBrowserType } from '../PdfViewer/helper';

const {
    isChrome,
} = getCurrentBrowserType();

const Styled = styled.div`
    .delete-btn {
        position: absolute;
        z-index: 10;
    }
    
    .ant-upload.ant-upload-select {
        display: table;
        
        .anticon {
            font-size: 24px;
        }
    }

    .bukku-upload {
        &.disabled {
            .ant-upload.ant-upload-select{
                &:hover, &:focus, &:active {
                    /* revert the hovered blue border to normal greyish border (no transitions) */
                    cursor: default;
                    border-color: #d9d9d9;      
                    transition: color 0.3s;
                }              
            }
        }
    }

    .ant-spin-nested-loading {
        width: 100%;
        height: 100%;

        .ant-spin-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%; 

            /* when no image */
            .upload-placeholder {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;  
                width: 100%;
                height: 100px;
                min-height: inherit;
            }

            /* when there is an image */
            .ant-image {
                img {
                    max-height: 200px;
                }
            }
        }
    }

    .disabled {
        color: rgba(0, 0, 0, 25%);
    }

    .upload-img-container {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 160px;
        height: 100%;
        min-height: 160px;

        /* hoverable mask */
        .upload-img-mask {
            position: absolute;
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: inherit;
            height: ${isChrome ? 'fill-available' : '97%'}; /* 97% height would cause least amount of overflow */
            min-height: inherit;
            max-height: 200px;
            background: rgb(0,0,0,50%);
            opacity: 0;
            transition: opacity 0.3s;

            &:hover, &:focus, &:active {
                opacity: 1;
            }

            .anticon {
                color: #ffffffd9;
                
                &:hover, &:focus, &:active {
                    color: #fff;
                    transition: color 0.3s;
                }
            }
        }
            
      
    }
`;

export { Styled };
